export const PARTNER_TYPE:any = {
    "1": '개인',
    "2": '사업자',
}

export const PARTNER_STATUS:any = {
    "0": '대기',
    "1": '승인',
    "2": '거절',
}